import { AbstractControl, ValidatorFn } from '@angular/forms'

export function orgnumberFormatValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {

        let orgNumberRegEx = /^\d{9}$/;

        const val: string = control.value;
        let retVal = null;

        if (val === undefined || val === null || val === '') {
            return null;
        }
        if (!orgNumberRegEx.test(val)) {
            retVal = { invalidFormat: { value: control.value } };
        }
        
        return retVal;

    }
}

